var _g, _circle, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 104,
    viewBox: "0 0 100 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11.6274,
    width: 2.83105,
    height: 82.3723,
    rx: 1.41553,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.22943,
    height: 7.96657,
    rx: 1.61471,
    transform: "matrix(0.459843 0.888 -0.840857 0.541258 25.8203 87.377)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.22944,
    height: 7.96658,
    rx: 1.61472,
    transform: "matrix(-0.459842 0.888001 -0.840856 -0.54126 81 91.689)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.52,
    y: 11.6274,
    width: 2.48,
    height: 82.3723,
    rx: 1.24,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.6987,
    y: 19.9849,
    width: 58.3196,
    height: 13.959,
    rx: 2,
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.6536 9.6416L43.6148 10.2943L43.4401 15.0155H41.6543L41.4602 10.2943L41.4214 9.6416H43.6536Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6536 9.6416L43.6148 10.2943H41.4602L41.4214 9.6416H43.6536Z",
    fill: "#CB7569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9537 9.79388H40.1399C40.1205 9.79388 40.1011 9.79388 40.1011 9.77212V8.92361C40.1011 8.92361 40.1205 8.90186 40.1399 8.90186H44.9537C44.9731 8.90186 44.9731 8.92361 44.9731 8.92361V9.77212C44.9731 9.79388 44.9731 9.79388 44.9537 9.79388Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2751 72.8534H41.8343C41.7584 72.8534 41.6978 72.7709 41.6978 72.6679V70.2563H43.3964V72.6679C43.3964 72.7709 43.3357 72.8534 43.2751 72.8534Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2822 50.1294H42.5471V64.7376H41.4146C41.4146 64.7376 41.2529 55.3884 40.2822 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.812 50.1294H42.5472V64.7376H43.6796C43.6796 64.7376 43.8414 55.3884 44.812 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4146 51.5865C41.4146 50.9611 41.9216 50.4541 42.547 50.4541V50.4541C43.1724 50.4541 43.6794 50.9611 43.6794 51.5865V70.4224C43.6794 71.0478 43.1724 71.5548 42.547 71.5548V71.5548C41.9216 71.5548 41.4146 71.0478 41.4146 70.4224V51.5865Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3784 44.9355H39.7163V50.1296C39.7163 50.4881 40.9838 50.7788 42.5474 50.7788C44.1109 50.7788 45.3784 50.4881 45.3784 50.1296V44.9355Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2254 14.1502V14.9335C45.2254 15.064 45.1284 15.1728 45.0119 15.1728H44.2743V18.9367H40.8193V15.1728H40.0817C39.9652 15.1728 39.8682 15.064 39.8682 14.9335V14.1502C39.8682 13.9979 39.9652 13.8892 40.0817 13.8892L45.0119 13.8892C45.1284 13.8892 45.2254 13.9979 45.2254 14.1502Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1499 45.9091L39.1499 19.4587C39.1499 19.0018 39.3634 18.6102 39.7322 18.4143L40.8192 17.8269L42.5661 16.8696L44.1384 17.7181L45.3806 18.4143C45.73 18.6102 45.9435 18.8328 45.9435 19.2897V45.894C45.9441 45.899 45.9444 45.9041 45.9444 45.9091C45.9444 46.2676 44.4234 46.5583 42.5472 46.5583C40.6709 46.5583 39.1499 46.2676 39.1499 45.9091Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 16,
    width: 7,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1499 45.9091L39.1499 19.4587C39.1499 19.0018 39.3634 18.6102 39.7322 18.4143L40.8192 17.8269L42.5661 16.8696L44.1384 17.7181L45.3806 18.4143C45.73 18.6102 45.9435 18.8328 45.9435 19.2897V45.894C45.9441 45.899 45.9444 45.9041 45.9444 45.9091C45.9444 46.2676 44.4234 46.5583 42.5472 46.5583C40.6709 46.5583 39.1499 46.2676 39.1499 45.9091Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.1499,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2456,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.566 17.0005C43.295 17.0005 43.8859 16.7375 43.8859 16.4131C43.8859 16.0887 43.295 15.8257 42.566 15.8257C41.837 15.8257 41.2461 16.0887 41.2461 16.4131C41.2461 16.7375 41.837 17.0005 42.566 17.0005Z",
    fill: "#E9DB3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0506 17.3485C44.6624 16.6523 44.0607 16.1302 43.3813 15.9126C43.2454 16.0214 42.9349 16.0867 42.5467 16.0867C42.1779 16.0867 41.8867 16.0214 41.7314 15.9344C41.0521 16.1737 40.4309 16.6523 40.0427 17.3703C39.9069 17.6314 39.8486 17.9577 39.8486 18.2623V21.243C39.8486 21.4823 40.0427 21.6563 40.2563 21.6346C40.8968 21.504 41.6538 21.417 42.4884 21.417C43.3813 21.417 44.1577 21.504 44.8371 21.6346C45.0506 21.6781 45.2447 21.504 45.2447 21.243V18.2188C45.2447 17.9142 45.1865 17.6096 45.0506 17.3485Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1216 17.8489C40.3933 17.4355 40.7815 17.1309 41.1892 16.8916C41.4027 16.7828 41.6162 16.6958 41.8491 16.6305C42.082 16.5652 42.315 16.5435 42.5479 16.5435C43.0137 16.5435 43.499 16.6522 43.9066 16.8916C44.3336 17.1091 44.7024 17.4355 44.9742 17.8489C44.586 17.566 44.1978 17.3485 43.7901 17.1962C43.5766 17.1309 43.3825 17.0656 43.169 17.0221C42.9555 16.9786 42.742 16.9568 42.5285 16.9568C42.1014 16.9568 41.6744 17.0439 41.2668 17.1744C40.898 17.3485 40.4904 17.566 40.1216 17.8489Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9435 14.7377L41.9253 14.0415H41.6535L41.617 14.7377H41.1663L41.1298 14.0416H40.8775L40.8409 14.7377H40.3909L40.3544 14.0416H40.0827L40.0644 14.7377H39.8682V14.9335C39.8682 15.064 39.9652 15.1728 40.0817 15.1728L45.0119 15.1728C45.1284 15.1728 45.2254 15.064 45.2254 14.9335V14.7377H45.0675L45.0309 14.0416H44.7786L44.7421 14.7377H44.2917L44.2552 14.0416H44.0028L43.9663 14.7377L43.5157 14.7377L43.4791 14.0415L43.2074 14.0415L43.1891 14.7377H42.7397L42.7031 14.0415H42.4314L42.3949 14.7377H41.9435Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2938 15.1729H40.8193V15.4774H44.2938V15.1729Z",
    fill: "#336589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6794 28.3794H41.4146V37.4402H43.6794V28.3794Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.206 30.208H41.9155V35.4753H43.206V30.208Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.206 30.208H41.9155V30.3172H43.206V30.208Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.206 35.3936H41.9155V35.5027H43.206V35.3936Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.206 33.6738H41.9155V33.783H43.206V33.6738Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.206 31.9272H41.9155V32.0364H43.206V31.9272Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5807 30.729C42.6663 30.729 42.7343 30.7562 42.7846 30.8105C42.8353 30.8643 42.8607 30.9363 42.8607 31.0263C42.8607 31.095 42.8418 31.1693 42.8039 31.2493C42.7665 31.3294 42.7005 31.4354 42.6059 31.5674H42.9149V31.7404H42.3311V31.7196C42.399 31.6267 42.4573 31.5433 42.5059 31.4695C42.5549 31.3951 42.5928 31.3337 42.6194 31.2851C42.6461 31.236 42.665 31.1943 42.6762 31.16C42.6874 31.1257 42.693 31.0902 42.693 31.0535C42.693 31.0078 42.6796 30.9694 42.653 30.9384C42.6267 30.907 42.5947 30.8913 42.5569 30.8913C42.4889 30.8913 42.4184 30.9341 42.3452 31.0199V30.8241C42.4222 30.7607 42.5007 30.729 42.5807 30.729Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6271 32.4395C42.7183 32.4395 42.7906 32.485 42.8439 32.576C42.8977 32.667 42.9246 32.7913 42.9246 32.9491C42.9246 33.1082 42.8981 33.2338 42.8452 33.3257C42.7923 33.4177 42.72 33.4637 42.6284 33.4637C42.5355 33.4637 42.462 33.4182 42.4078 33.3272C42.354 33.2357 42.3271 33.1106 42.3271 32.9519C42.3271 32.7937 42.354 32.6689 42.4078 32.5774C42.4616 32.4854 42.5347 32.4395 42.6271 32.4395ZM42.4949 32.9576C42.4949 33.1859 42.539 33.3 42.6271 33.3C42.7132 33.3 42.7562 33.1799 42.7562 32.9398C42.7562 32.7153 42.7127 32.6031 42.6259 32.6031C42.5385 32.6031 42.4949 32.7213 42.4949 32.9576Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6286 34.1401C42.7198 34.1401 42.792 34.1856 42.8454 34.2767C42.8991 34.3677 42.926 34.492 42.926 34.6497C42.926 34.8089 42.8996 34.9344 42.8467 35.0264C42.7938 35.1184 42.7215 35.1644 42.6299 35.1644C42.537 35.1644 42.4634 35.1188 42.4093 35.0278C42.3555 34.9364 42.3286 34.8113 42.3286 34.6526C42.3286 34.4944 42.3555 34.3696 42.4093 34.2781C42.463 34.1861 42.5361 34.1401 42.6286 34.1401ZM42.4964 34.6583C42.4964 34.8866 42.5404 35.0007 42.6286 35.0007C42.7146 35.0007 42.7576 34.8806 42.7576 34.6405C42.7576 34.416 42.7142 34.3038 42.6273 34.3038C42.54 34.3038 42.4964 34.422 42.4964 34.6583Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2255 18.3273V21.2427C45.2255 21.482 45.0508 21.6561 44.8179 21.6126C44.6044 21.5691 44.3715 21.5473 44.1191 21.5038V17.8052C44.4297 17.9357 44.6044 18.0445 44.8761 18.175C45.0897 18.2403 45.0897 18.2403 45.2255 18.3273Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8682 18.3278V21.2432C39.8682 21.4825 40.0429 21.6566 40.2758 21.6131C40.4893 21.5696 40.7222 21.5478 40.9746 21.5043V17.8057C40.664 17.9362 40.4893 18.045 40.2176 18.1755C40.004 18.2408 40.004 18.2408 39.8682 18.3278Z",
    fill: "#D67568"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.2234 9.6416L58.1846 10.2943L58.0099 15.0155H56.2241L56.03 10.2943L55.9912 9.6416H58.2234Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2234 9.6416L58.1846 10.2943H56.03L55.9912 9.6416H58.2234Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5235 9.79388H54.7097C54.6903 9.79388 54.6709 9.79388 54.6709 9.77212V8.92361C54.6709 8.92361 54.6903 8.90186 54.7097 8.90186H59.5235C59.5429 8.90186 59.5429 8.92361 59.5429 8.92361V9.77212C59.5429 9.79388 59.5429 9.79388 59.5235 9.79388Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8449 72.8534H56.4041C56.3282 72.8534 56.2676 72.7709 56.2676 72.6679V70.2563H57.9662V72.6679C57.9662 72.7709 57.9055 72.8534 57.8449 72.8534Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8521 50.1294H57.1169V64.7376H55.9845C55.9845 64.7376 55.8227 55.3884 54.8521 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3818 50.1294H57.117V64.7376H58.2494C58.2494 64.7376 58.4112 55.3884 59.3818 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9844 51.5865C55.9844 50.9611 56.4914 50.4541 57.1168 50.4541V50.4541C57.7422 50.4541 58.2492 50.9611 58.2492 51.5865V70.4224C58.2492 71.0478 57.7422 71.5548 57.1168 71.5548V71.5548C56.4914 71.5548 55.9844 71.0478 55.9844 70.4224V51.5865Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9482 44.9355H54.2861V50.1296C54.2861 50.4881 55.5536 50.7788 57.1172 50.7788C58.6807 50.7788 59.9482 50.4881 59.9482 50.1296V44.9355Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7953 14.1502V14.9335C59.7953 15.064 59.6982 15.1728 59.5817 15.1728H58.8441V18.9367H55.3891V15.1728H54.6515C54.535 15.1728 54.438 15.064 54.438 14.9335V14.1502C54.438 13.9979 54.535 13.8892 54.6515 13.8892L59.5817 13.8892C59.6982 13.8892 59.7953 13.9979 59.7953 14.1502Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7197 45.9091L53.7197 19.4587C53.7197 19.0018 53.9332 18.6102 54.302 18.4143L55.389 17.8269L57.136 16.8696L58.7082 17.7181L59.9505 18.4143C60.2998 18.6102 60.5134 18.8328 60.5134 19.2897V45.894C60.514 45.899 60.5142 45.9041 60.5142 45.9091C60.5142 46.2676 58.9932 46.5583 57.117 46.5583C55.2407 46.5583 53.7197 46.2676 53.7197 45.9091Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 16,
    width: 8,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7197 45.9091L53.7197 19.4587C53.7197 19.0018 53.9332 18.6102 54.302 18.4143L55.389 17.8269L57.136 16.8696L58.7082 17.7181L59.9505 18.4143C60.2998 18.6102 60.5134 18.8328 60.5134 19.2897V45.894C60.514 45.899 60.5142 45.9041 60.5142 45.9091C60.5142 46.2676 58.9932 46.5583 57.117 46.5583C55.2407 46.5583 53.7197 46.2676 53.7197 45.9091Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.7197,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8154,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.1358 17.0005C57.8648 17.0005 58.4557 16.7375 58.4557 16.4131C58.4557 16.0887 57.8648 15.8257 57.1358 15.8257C56.4069 15.8257 55.8159 16.0887 55.8159 16.4131C55.8159 16.7375 56.4069 17.0005 57.1358 17.0005Z",
    fill: "#E9DB3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6204 17.3485C59.2322 16.6523 58.6305 16.1302 57.9511 15.9126C57.8153 16.0214 57.5047 16.0867 57.1165 16.0867C56.7477 16.0867 56.4565 16.0214 56.3013 15.9344C55.6219 16.1737 55.0008 16.6523 54.6126 17.3703C54.4767 17.6314 54.4185 17.9577 54.4185 18.2623V21.243C54.4185 21.4823 54.6126 21.6563 54.8261 21.6346C55.4666 21.504 56.2236 21.417 57.0583 21.417C57.9511 21.417 58.7276 21.504 59.4069 21.6346C59.6204 21.6781 59.8145 21.504 59.8145 21.243V18.2188C59.8145 17.9142 59.7563 17.6096 59.6204 17.3485Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6914 17.8489C54.9632 17.4355 55.3514 17.1309 55.759 16.8916C55.9725 16.7828 56.186 16.6958 56.4189 16.6305C56.6519 16.5652 56.8848 16.5435 57.1177 16.5435C57.5836 16.5435 58.0688 16.6522 58.4764 16.8916C58.9035 17.1091 59.2723 17.4355 59.544 17.8489C59.1558 17.566 58.7676 17.3485 58.36 17.1962C58.1465 17.1309 57.9523 17.0656 57.7388 17.0221C57.5253 16.9786 57.3118 16.9568 57.0983 16.9568C56.6713 16.9568 56.2442 17.0439 55.8366 17.1744C55.4678 17.3485 55.0602 17.566 54.6914 17.8489Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5133 14.7377L56.4951 14.0415H56.2233L56.1868 14.7377H55.7362L55.6996 14.0416H55.4473L55.4108 14.7377H54.9608L54.9242 14.0416H54.6525L54.6342 14.7377H54.438V14.9335C54.438 15.064 54.535 15.1728 54.6515 15.1728L59.5817 15.1728C59.6982 15.1728 59.7953 15.064 59.7953 14.9335V14.7377H59.6373L59.6008 14.0416H59.3484L59.3119 14.7377H58.8615L58.825 14.0416H58.5727L58.5361 14.7377L58.0855 14.7377L58.049 14.0415L57.7772 14.0415L57.759 14.7377H57.3095L57.273 14.0415H57.0012L56.9647 14.7377H56.5133Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8636 15.1729H55.3892V15.4774H58.8636V15.1729Z",
    fill: "#336589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2492 28.3794H55.9844V37.4402H58.2492V28.3794Z",
    fill: "#54BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7758 30.208H56.4854V35.4753H57.7758V30.208Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7758 30.208H56.4854V30.3172H57.7758V30.208Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7758 35.3936H56.4854V35.5027H57.7758V35.3936Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7758 33.6738H56.4854V33.783H57.7758V33.6738Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7758 31.9272H56.4854V32.0364H57.7758V31.9272Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1506 30.729C57.2361 30.729 57.3041 30.7562 57.3544 30.8105C57.4052 30.8643 57.4305 30.9363 57.4305 31.0263C57.4305 31.095 57.4116 31.1693 57.3738 31.2493C57.3364 31.3294 57.2703 31.4354 57.1757 31.5674H57.4847V31.7404H56.9009V31.7196C56.9688 31.6267 57.0271 31.5433 57.0757 31.4695C57.1247 31.3951 57.1626 31.3337 57.1893 31.2851C57.2159 31.236 57.2349 31.1943 57.246 31.16C57.2572 31.1257 57.2628 31.0902 57.2628 31.0535C57.2628 31.0078 57.2495 30.9694 57.2228 30.9384C57.1966 30.907 57.1645 30.8913 57.1267 30.8913C57.0587 30.8913 56.9882 30.9341 56.9151 31.0199V30.8241C56.9921 30.7607 57.0706 30.729 57.1506 30.729Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.197 32.4395C57.2881 32.4395 57.3604 32.485 57.4137 32.576C57.4675 32.667 57.4944 32.7913 57.4944 32.9491C57.4944 33.1082 57.4679 33.2338 57.415 33.3257C57.3621 33.4177 57.2899 33.4637 57.1983 33.4637C57.1054 33.4637 57.0318 33.4182 56.9776 33.3272C56.9239 33.2357 56.897 33.1106 56.897 32.9519C56.897 32.7937 56.9239 32.6689 56.9776 32.5774C57.0314 32.4854 57.1045 32.4395 57.197 32.4395ZM57.0647 32.9576C57.0647 33.1859 57.1088 33.3 57.197 33.3C57.283 33.3 57.326 33.1799 57.326 32.9398C57.326 32.7153 57.2826 32.6031 57.1957 32.6031C57.1084 32.6031 57.0647 32.7213 57.0647 32.9576Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1984 34.1401C57.2896 34.1401 57.3619 34.1856 57.4152 34.2767C57.469 34.3677 57.4958 34.492 57.4958 34.6497C57.4958 34.8089 57.4694 34.9344 57.4165 35.0264C57.3636 35.1184 57.2913 35.1644 57.1997 35.1644C57.1068 35.1644 57.0333 35.1188 56.9791 35.0278C56.9253 34.9364 56.8984 34.8113 56.8984 34.6526C56.8984 34.4944 56.9253 34.3696 56.9791 34.2781C57.0328 34.1861 57.106 34.1401 57.1984 34.1401ZM57.0662 34.6583C57.0662 34.8866 57.1103 35.0007 57.1984 35.0007C57.2845 35.0007 57.3275 34.8806 57.3275 34.6405C57.3275 34.416 57.284 34.3038 57.1971 34.3038C57.1098 34.3038 57.0662 34.422 57.0662 34.6583Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7954 18.3273V21.2427C59.7954 21.482 59.6207 21.6561 59.3877 21.6126C59.1742 21.5691 58.9413 21.5473 58.689 21.5038V17.8052C58.9995 17.9357 59.1742 18.0445 59.446 18.175C59.6595 18.2403 59.6595 18.2403 59.7954 18.3273Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.438 18.3278V21.2432C54.438 21.4825 54.6127 21.6566 54.8456 21.6131C55.0591 21.5696 55.292 21.5478 55.5444 21.5043V17.8057C55.2338 17.9362 55.0591 18.045 54.7874 18.1755C54.5739 18.2408 54.5739 18.2408 54.438 18.3278Z",
    fill: "#3295BA"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.4003 91.3572H56.8341L56.2207 78.5508H58.0137L57.4003 91.3572Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.5038 78.5508H56.2207L56.8341 91.3572H56.8813L56.5038 78.5508Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.73 78.5508L57.3525 91.3572H57.3997L58.0131 78.5508H57.73Z",
    fill: "#FEF9E1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.9665 79.0456L58.0137 78.7158H56.2207V79.0456H57.9665Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.0607 78.9355H56.1733L56.0317 76.0225H58.155L58.0607 78.9355Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.5509 78.9355H56.1738L56.0322 76.0225H56.4093L56.5509 78.9355Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.6835 78.9355H58.0606L58.2021 76.0225H57.825L57.6835 78.9355Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.1082 76.2146L58.1553 75.7749H55.9849V76.2146H58.1082Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.2971 76.1872H55.9379L55.7964 70.6909H58.3915L58.2971 76.1872Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M56.4096 76.1872H55.9379L55.7964 70.6909H56.268L56.4096 76.1872Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.7779 76.1872H58.2496L58.3911 70.6909H57.9195L57.7779 76.1872Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.3915 71.4056L58.4387 70.856H55.7964V71.4056H58.3915Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.5327 70.5811H55.7017V71.2406H58.5327V70.5811Z",
    fill: "#FEF9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4096 75.7752L56.1265 70.9058H56.4096V75.7752Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8247 75.7752V70.9058H58.1078L57.8247 75.7752Z",
    fill: "#EDE3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.1928 76.2622H56.041L56.0695 76.5868H58.1645L58.1928 76.2622Z",
    fill: "#CCB450"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.995 79.0215H56.2681L56.2966 79.3461H57.9667L57.995 79.0215Z",
    fill: "#CCB450"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.7937 9.6416L72.7549 10.2943L72.5802 15.0155H70.7944L70.6003 10.2943L70.5615 9.6416H72.7937Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7937 9.6416L72.7549 10.2943H70.6003L70.5615 9.6416H72.7937Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0938 9.79388H69.28C69.2606 9.79388 69.2412 9.79388 69.2412 9.77212V8.92361C69.2412 8.92361 69.2606 8.90186 69.28 8.90186H74.0938C74.1132 8.90186 74.1132 8.92361 74.1132 8.92361V9.77212C74.1132 9.79388 74.1132 9.79388 74.0938 9.79388Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4152 72.8534H70.9744C70.8986 72.8534 70.8379 72.7709 70.8379 72.6679V70.2563H72.5365V72.6679C72.5365 72.7709 72.4759 72.8534 72.4152 72.8534Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4224 50.1294H71.6872V64.7376H70.5548C70.5548 64.7376 70.393 55.3884 69.4224 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9521 50.1294H71.6873V64.7376H72.8197C72.8197 64.7376 72.9815 55.3884 73.9521 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5547 51.5865C70.5547 50.9611 71.0617 50.4541 71.6871 50.4541V50.4541C72.3125 50.4541 72.8195 50.9611 72.8195 51.5865V70.4224C72.8195 71.0478 72.3125 71.5548 71.6871 71.5548V71.5548C71.0617 71.5548 70.5547 71.0478 70.5547 70.4224V51.5865Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5185 44.9355H68.8564V50.1296C68.8564 50.4881 70.1239 50.7788 71.6875 50.7788C73.251 50.7788 74.5185 50.4881 74.5185 50.1296V44.9355Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3656 14.1502V14.9335C74.3656 15.064 74.2685 15.1728 74.152 15.1728H73.4145V18.9367H69.9594V15.1728H69.2218C69.1054 15.1728 69.0083 15.064 69.0083 14.9335V14.1502C69.0083 13.9979 69.1054 13.8892 69.2218 13.8892L74.152 13.8892C74.2685 13.8892 74.3656 13.9979 74.3656 14.1502Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.29 45.9091V19.4587C68.29 19.0018 68.5036 18.6102 68.8724 18.4143L69.9593 17.8269L71.7063 16.8696L73.2785 17.7181L74.5208 18.4143C74.8702 18.6102 75.0837 18.8328 75.0837 19.2897V45.894C75.0843 45.899 75.0846 45.9041 75.0846 45.9091C75.0846 46.2676 73.5636 46.5583 71.6873 46.5583C69.811 46.5583 68.29 46.2676 68.29 45.9091Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 16,
    width: 8,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.29 45.9091V19.4587C68.29 19.0018 68.5036 18.6102 68.8724 18.4143L69.9593 17.8269L71.7063 16.8696L73.2785 17.7181L74.5208 18.4143C74.8702 18.6102 75.0837 18.8328 75.0837 19.2897V45.894C75.0843 45.899 75.0846 45.9041 75.0846 45.9091C75.0846 46.2676 73.5636 46.5583 71.6873 46.5583C69.811 46.5583 68.29 46.2676 68.29 45.9091Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.29,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3857,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.7061 17.0005C72.4351 17.0005 73.026 16.7375 73.026 16.4131C73.026 16.0887 72.4351 15.8257 71.7061 15.8257C70.9772 15.8257 70.3862 16.0887 70.3862 16.4131C70.3862 16.7375 70.9772 17.0005 71.7061 17.0005Z",
    fill: "#E9DB3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1907 17.3485C73.8025 16.6523 73.2008 16.1302 72.5215 15.9126C72.3856 16.0214 72.075 16.0867 71.6868 16.0867C71.318 16.0867 71.0269 16.0214 70.8716 15.9344C70.1922 16.1737 69.5711 16.6523 69.1829 17.3703C69.047 17.6314 68.9888 17.9577 68.9888 18.2623V21.243C68.9888 21.4823 69.1829 21.6563 69.3964 21.6346C70.0369 21.504 70.7939 21.417 71.6286 21.417C72.5215 21.417 73.2979 21.504 73.9772 21.6346C74.1907 21.6781 74.3849 21.504 74.3849 21.243V18.2188C74.3849 17.9142 74.3266 17.6096 74.1907 17.3485Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2617 17.8489C69.5335 17.4355 69.9217 17.1309 70.3293 16.8916C70.5428 16.7828 70.7563 16.6958 70.9892 16.6305C71.2222 16.5652 71.4551 16.5435 71.688 16.5435C72.1539 16.5435 72.6391 16.6522 73.0467 16.8916C73.4738 17.1091 73.8426 17.4355 74.1143 17.8489C73.7261 17.566 73.3379 17.3485 72.9303 17.1962C72.7168 17.1309 72.5227 17.0656 72.3091 17.0221C72.0956 16.9786 71.8821 16.9568 71.6686 16.9568C71.2416 16.9568 70.8145 17.0439 70.4069 17.1744C70.0381 17.3485 69.6305 17.566 69.2617 17.8489Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0837 14.7377L71.0654 14.0415H70.7936L70.7571 14.7377H70.3065L70.2699 14.0416H70.0176L69.9811 14.7377H69.5311L69.4945 14.0416H69.2228L69.2045 14.7377H69.0083V14.9335C69.0083 15.064 69.1054 15.1728 69.2218 15.1728L74.152 15.1728C74.2685 15.1728 74.3656 15.064 74.3656 14.9335V14.7377H74.2076L74.1711 14.0416H73.9187L73.8822 14.7377H73.4318L73.3953 14.0416H73.143L73.1065 14.7377L72.6558 14.7377L72.6193 14.0415L72.3475 14.0415L72.3293 14.7377H71.8798L71.8433 14.0415H71.5715L71.535 14.7377H71.0837Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4339 15.1729H69.9595V15.4774H73.4339V15.1729Z",
    fill: "#336589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8195 28.3794H70.5547V37.4402H72.8195V28.3794Z",
    fill: "#B0E298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3461 30.208H71.0557V35.4753H72.3461V30.208Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3461 30.208H71.0557V30.3172H72.3461V30.208Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3461 35.3936H71.0557V35.5027H72.3461V35.3936Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3461 33.6738H71.0557V33.783H72.3461V33.6738Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3461 31.9272H71.0557V32.0364H72.3461V31.9272Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7209 30.729C71.8065 30.729 71.8744 30.7562 71.9247 30.8105C71.9755 30.8643 72.0009 30.9363 72.0009 31.0263C72.0009 31.095 71.9819 31.1693 71.9441 31.2493C71.9067 31.3294 71.8406 31.4354 71.746 31.5674H72.0551V31.7404H71.4712V31.7196C71.5391 31.6267 71.5974 31.5433 71.646 31.4695C71.6951 31.3951 71.7329 31.3337 71.7596 31.2851C71.7862 31.236 71.8052 31.1943 71.8163 31.16C71.8275 31.1257 71.8331 31.0902 71.8331 31.0535C71.8331 31.0078 71.8198 30.9694 71.7931 30.9384C71.7669 30.907 71.7348 30.8913 71.697 30.8913C71.629 30.8913 71.5585 30.9341 71.4854 31.0199V30.8241C71.5624 30.7607 71.6409 30.729 71.7209 30.729Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7673 32.4395C71.8585 32.4395 71.9307 32.485 71.984 32.576C72.0378 32.667 72.0647 32.7913 72.0647 32.9491C72.0647 33.1082 72.0382 33.2338 71.9853 33.3257C71.9324 33.4177 71.8602 33.4637 71.7686 33.4637C71.6757 33.4637 71.6021 33.4182 71.5479 33.3272C71.4942 33.2357 71.4673 33.1106 71.4673 32.9519C71.4673 32.7937 71.4942 32.6689 71.5479 32.5774C71.6017 32.4854 71.6748 32.4395 71.7673 32.4395ZM71.635 32.9576C71.635 33.1859 71.6791 33.3 71.7673 33.3C71.8533 33.3 71.8963 33.1799 71.8963 32.9398C71.8963 32.7153 71.8529 32.6031 71.766 32.6031C71.6787 32.6031 71.635 32.7213 71.635 32.9576Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7687 34.1401C71.8599 34.1401 71.9322 34.1856 71.9855 34.2767C72.0393 34.3677 72.0662 34.492 72.0662 34.6497C72.0662 34.8089 72.0397 34.9344 71.9868 35.0264C71.9339 35.1184 71.8616 35.1644 71.77 35.1644C71.6771 35.1644 71.6036 35.1188 71.5494 35.0278C71.4956 34.9364 71.4688 34.8113 71.4688 34.6526C71.4688 34.4944 71.4956 34.3696 71.5494 34.2781C71.6032 34.1861 71.6763 34.1401 71.7687 34.1401ZM71.6365 34.6583C71.6365 34.8866 71.6806 35.0007 71.7687 35.0007C71.8548 35.0007 71.8978 34.8806 71.8978 34.6405C71.8978 34.416 71.8543 34.3038 71.7675 34.3038C71.6801 34.3038 71.6365 34.422 71.6365 34.6583Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3657 18.3273V21.2427C74.3657 21.482 74.191 21.6561 73.9581 21.6126C73.7445 21.5691 73.5116 21.5473 73.2593 21.5038V17.8052C73.5698 17.9357 73.7445 18.0445 74.0163 18.175C74.2298 18.2403 74.2298 18.2403 74.3657 18.3273Z",
    fill: "#8BB975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0083 18.3278V21.2432C69.0083 21.4825 69.183 21.6566 69.4159 21.6131C69.6294 21.5696 69.8624 21.5478 70.1147 21.5043V17.8057C69.8041 17.9362 69.6294 18.045 69.3577 18.1755C69.1442 18.2408 69.1442 18.2408 69.0083 18.3278Z",
    fill: "#8BB975"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.0838 9.6416L29.0449 10.2943L28.8702 15.0155H27.0845L26.8904 10.2943L26.8516 9.6416H29.0838Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0838 9.6416L29.0449 10.2943H26.8904L26.8516 9.6416H29.0838Z",
    fill: "#E4C76A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3838 9.79388H25.5701C25.5507 9.79388 25.5312 9.79388 25.5312 9.77212V8.92361C25.5312 8.92361 25.5507 8.90186 25.5701 8.90186H30.3838C30.4033 8.90186 30.4033 8.92361 30.4033 8.92361V9.77212C30.4033 9.79388 30.4033 9.79388 30.3838 9.79388Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7052 72.8534H27.2644C27.1886 72.8534 27.1279 72.7709 27.1279 72.6679V70.2563H28.8266V72.6679C28.8266 72.7709 28.7659 72.8534 28.7052 72.8534Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7124 50.1294H27.9772V64.7376H26.8448C26.8448 64.7376 26.683 55.3884 25.7124 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2422 50.1294H27.9773V64.7376H29.1098C29.1098 64.7376 29.2715 55.3884 30.2422 50.1294Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8447 51.5865C26.8447 50.9611 27.3517 50.4541 27.9771 50.4541V50.4541C28.6026 50.4541 29.1096 50.9611 29.1096 51.5865V70.4224C29.1096 71.0478 28.6026 71.5548 27.9771 71.5548V71.5548C27.3517 71.5548 26.8447 71.0478 26.8447 70.4224V51.5865Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8086 44.9355H25.1465V50.1296C25.1465 50.4881 26.414 50.7788 27.9775 50.7788C29.5411 50.7788 30.8086 50.4881 30.8086 50.1296V44.9355Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6556 14.1502V14.9335C30.6556 15.064 30.5586 15.1728 30.4421 15.1728H29.7045V18.9367H26.2494V15.1728H25.5119C25.3954 15.1728 25.2983 15.064 25.2983 14.9335V14.1502C25.2983 13.9979 25.3954 13.8892 25.5119 13.8892L30.4421 13.8892C30.5586 13.8892 30.6556 13.9979 30.6556 14.1502Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5801 45.9091L24.5801 19.4587C24.5801 19.0018 24.7936 18.6102 25.1624 18.4143L26.2494 17.8269L27.9963 16.8696L29.5685 17.7181L30.8108 18.4143C31.1602 18.6102 31.3737 18.8328 31.3737 19.2897L31.3737 45.894C31.3743 45.899 31.3746 45.9041 31.3746 45.9091C31.3746 46.2676 29.8536 46.5583 27.9773 46.5583C26.1011 46.5583 24.5801 46.2676 24.5801 45.9091Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 8,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5801 45.9091L24.5801 19.4587C24.5801 19.0018 24.7936 18.6102 25.1624 18.4143L26.2494 17.8269L27.9963 16.8696L29.5685 17.7181L30.8108 18.4143C31.1602 18.6102 31.3737 18.8328 31.3737 19.2897L31.3737 45.894C31.3743 45.899 31.3746 45.9041 31.3746 45.9091C31.3746 46.2676 29.8536 46.5583 27.9773 46.5583C26.1011 46.5583 24.5801 46.2676 24.5801 45.9091Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5801,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6758,
    y: 18.3159,
    width: 1.69863,
    height: 28.2425,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.9962 17.0005C28.7251 17.0005 29.3161 16.7375 29.3161 16.4131C29.3161 16.0887 28.7251 15.8257 27.9962 15.8257C27.2672 15.8257 26.6763 16.0887 26.6763 16.4131C26.6763 16.7375 27.2672 17.0005 27.9962 17.0005Z",
    fill: "#E9DB3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4808 17.3485C30.0926 16.6523 29.4909 16.1302 28.8115 15.9126C28.6756 16.0214 28.3651 16.0867 27.9769 16.0867C27.6081 16.0867 27.3169 16.0214 27.1616 15.9344C26.4823 16.1737 25.8611 16.6523 25.4729 17.3703C25.337 17.6314 25.2788 17.9577 25.2788 18.2623V21.243C25.2788 21.4823 25.4729 21.6563 25.6864 21.6346C26.327 21.504 27.084 21.417 27.9186 21.417C28.8115 21.417 29.5879 21.504 30.2673 21.6346C30.4808 21.6781 30.6749 21.504 30.6749 21.243V18.2188C30.6749 17.9142 30.6167 17.6096 30.4808 17.3485Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5518 17.8489C25.8235 17.4355 26.2117 17.1309 26.6193 16.8916C26.8328 16.7828 27.0464 16.6958 27.2793 16.6305C27.5122 16.5652 27.7451 16.5435 27.9781 16.5435C28.4439 16.5435 28.9292 16.6522 29.3368 16.8916C29.7638 17.1091 30.1326 17.4355 30.4044 17.8489C30.0161 17.566 29.6279 17.3485 29.2203 17.1962C29.0068 17.1309 28.8127 17.0656 28.5992 17.0221C28.3857 16.9786 28.1722 16.9568 27.9586 16.9568C27.5316 16.9568 27.1046 17.0439 26.697 17.1744C26.3282 17.3485 25.9206 17.566 25.5518 17.8489Z",
    fill: "#E9CE78"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3737 14.7377L27.3554 14.0415H27.0837L27.0471 14.7377H26.5965L26.56 14.0416H26.3076L26.2711 14.7377H25.8211L25.7846 14.0416H25.5128L25.4946 14.7377H25.2983V14.9335C25.2983 15.064 25.3954 15.1728 25.5119 15.1728L30.4421 15.1728C30.5586 15.1728 30.6556 15.064 30.6556 14.9335V14.7377H30.4977L30.4611 14.0416H30.2088L30.1723 14.7377H29.7219L29.6854 14.0416H29.433L29.3965 14.7377L28.9459 14.7377L28.9093 14.0415L28.6376 14.0415L28.6193 14.7377H28.1699L28.1333 14.0415H27.8616L27.825 14.7377H27.3737Z",
    fill: "#668BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.724 15.1729H26.2495V15.4774H29.724V15.1729Z",
    fill: "#336589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1096 28.3794H26.8447V37.4402H29.1096V28.3794Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 30.208H27.3457V35.4753H28.6362V30.208Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 30.208H27.3457V30.3172H28.6362V30.208Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 35.3936H27.3457V35.5027H28.6362V35.3936Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 33.6738H27.3457V33.783H28.6362V33.6738Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6362 31.9272H27.3457V32.0364H28.6362V31.9272Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0109 30.729C28.0965 30.729 28.1644 30.7562 28.2148 30.8105C28.2655 30.8643 28.2909 30.9363 28.2909 31.0263C28.2909 31.095 28.272 31.1693 28.2341 31.2493C28.1967 31.3294 28.1307 31.4354 28.0361 31.5674H28.3451V31.7404H27.7612V31.7196C27.8292 31.6267 27.8875 31.5433 27.9361 31.4695C27.9851 31.3951 28.0229 31.3337 28.0496 31.2851C28.0763 31.236 28.0952 31.1943 28.1064 31.16C28.1176 31.1257 28.1232 31.0902 28.1232 31.0535C28.1232 31.0078 28.1098 30.9694 28.0832 30.9384C28.0569 30.907 28.0249 30.8913 27.987 30.8913C27.9191 30.8913 27.8485 30.9341 27.7754 31.0199V30.8241C27.8524 30.7607 27.9309 30.729 28.0109 30.729Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0573 32.4395C28.1485 32.4395 28.2208 32.485 28.2741 32.576C28.3279 32.667 28.3547 32.7913 28.3547 32.9491C28.3547 33.1082 28.3283 33.2338 28.2754 33.3257C28.2225 33.4177 28.1502 33.4637 28.0586 33.4637C27.9657 33.4637 27.8922 33.4182 27.838 33.3272C27.7842 33.2357 27.7573 33.1106 27.7573 32.9519C27.7573 32.7937 27.7842 32.6689 27.838 32.5774C27.8917 32.4854 27.9648 32.4395 28.0573 32.4395ZM27.9251 32.9576C27.9251 33.1859 27.9691 33.3 28.0573 33.3C28.1433 33.3 28.1863 33.1799 28.1863 32.9398C28.1863 32.7153 28.1429 32.6031 28.056 32.6031C27.9687 32.6031 27.9251 32.7213 27.9251 32.9576Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0588 34.1401C28.15 34.1401 28.2222 34.1856 28.2756 34.2767C28.3293 34.3677 28.3562 34.492 28.3562 34.6497C28.3562 34.8089 28.3297 34.9344 28.2768 35.0264C28.2239 35.1184 28.1517 35.1644 28.0601 35.1644C27.9672 35.1644 27.8936 35.1188 27.8394 35.0278C27.7857 34.9364 27.7588 34.8113 27.7588 34.6526C27.7588 34.4944 27.7857 34.3696 27.8394 34.2781C27.8932 34.1861 27.9663 34.1401 28.0588 34.1401ZM27.9265 34.6583C27.9265 34.8866 27.9706 35.0007 28.0588 35.0007C28.1448 35.0007 28.1878 34.8806 28.1878 34.6405C28.1878 34.416 28.1444 34.3038 28.0575 34.3038C27.9702 34.3038 27.9265 34.422 27.9265 34.6583Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6557 18.3273V21.2427C30.6557 21.482 30.481 21.6561 30.2481 21.6126C30.0346 21.5691 29.8017 21.5473 29.5493 21.5038V17.8052C29.8599 17.9357 30.0346 18.0445 30.3063 18.175C30.5198 18.2403 30.5198 18.2403 30.6557 18.3273Z",
    fill: "#E9CE78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2983 18.3278V21.2432C25.2983 21.4825 25.473 21.6566 25.706 21.6131C25.9195 21.5696 26.1524 21.5478 26.4047 21.5043V17.8057C26.0942 17.9362 25.9195 18.045 25.6477 18.1755C25.4342 18.2408 25.4342 18.2408 25.2983 18.3278Z",
    fill: "#E9CE78"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5005,
    cy: 83.5,
    r: 13,
    fill: "#FEF5F5",
    stroke: "#ED3431"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.0508,
    y: 76.9497,
    width: 17,
    height: 3,
    transform: "rotate(45 78.0508 76.9497)",
    fill: "#A41034"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.0718,
    y: 79.0713,
    width: 17,
    height: 3,
    transform: "rotate(135 90.0718 79.0713)",
    fill: "#A41034"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 16,
    y: 6,
    width: 68,
    height: 97.8235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 36.1499,
    y: 7.90186,
    width: 12.7945,
    height: 95.9216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 50.7197,
    y: 7.90186,
    width: 12.7945,
    height: 95.9216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 52.7017,
    y: 69.5811,
    width: 8.83105,
    height: 26.7762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 65.29,
    y: 7.90186,
    width: 12.7945,
    height: 95.9216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 21.5801,
    y: 7.90186,
    width: 12.7945,
    height: 95.9216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip3);
export default __webpack_public_path__ + "static/media/tip3.fd49ba0e952ccbb379b2ecc5a80610e8.svg";
export { ForwardRef as ReactComponent };